import ReactDOM from 'react-dom';

// ----------------------------------------------------------------------------

if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = function (component) {
        if (!component) {
            return null;
        }

        if (component.nodeType) {
            return component;
        }


        if (component._reactInternals) {
            const fiber = component._reactInternals;
            if (fiber.stateNode) {
                return fiber.stateNode;
            }
        }

        console.warn('findDOMNode is deprecated in StrictMode. findDOMNode was passed an instance that appears to be a React component. ' +
            'Instead, consider using a ref to directly access the DOM node.');

        return null;
    };
}